import React, { Component } from "react"
import './index.css';
import { Image } from 'react-bootstrap';
import CurrencyBoard from './currencyBoard.js';
import Clock from 'react-live-clock';
import axios from 'axios';
import store from "./store/index";
import moment from 'moment';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import { Auth } from "aws-amplify";
import DatePicker from './components/UI/DatePicker'
import { passDateToString } from './util/date/date-utils'
import { currentDateStr } from './util/date/date-utils'
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Dropdown from 'react-bootstrap/Dropdown';
import {Form} from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BfResult from './bfResult'
import { updateCurrentBets, updateDisplayConfirmBox, updateLoginToken } from "./actions";
import { connect } from "react-redux"
import { UPDATE_TOKEN } from "./constants/action-types";
import { API_BF_FUND, getLoginToken, clear, getCurrencySymbol, getUserName} from "./constants/utils";




const API3 = 'https://rpmapigreyhound.makebettinggreat.com/v1/greyhound/steamer-drifter';
// const API3 = 'http://localhost:8080/v1/horse/steamer-drifter';

function download_csv(csv, filename) {
  var csvFile;
  var downloadLink;

  // CSV FILE
  csvFile = new Blob([csv], { type: "text/csv" });

  // Download link
  downloadLink = document.createElement("a");

  // File name
  downloadLink.download = filename;

  // We have to create a link to the file
  downloadLink.href = window.URL.createObjectURL(csvFile);

  // Make sure that the link is not displayed
  downloadLink.style.display = "none";

  // Add the link to your DOM
  document.body.appendChild(downloadLink);

  // Lanzamos
  downloadLink.click();
}

function export_table_to_csv(html, filename) {
  var csv = [];
  var rows = html.querySelectorAll("table tr");

  for (var i = 0; i < rows.length; i++) {
    var row = [], cols = rows[i].querySelectorAll("td, th");

    for (var j = 0; j < cols.length; j++)
      row.push(cols[j].innerText);

    csv.push(row.join(","));
  }

  // Download CSV
  download_csv(csv.join("\n"), filename);
}

function clickEvent() {
  const marketName = document.querySelector("#selectedMarketDetails") !== null ? document.querySelector("#selectedMarketDetails").textContent : null;
  if (marketName !== null) {
    var html = document.querySelector("#runner_Odds_Table");
    export_table_to_csv(html, marketName + ".csv");
  } else {
    alert("Please load desired market odds before exporting.")
  }
}


function reloadPage() {
  // console.log("Reloading the page");
  window.location.reload();
}

function downloadTable() {
  //console.log("Download table to excel");
}
const postRequestPara = {
  "option": 1,
  "time": "20190408-14:15:40",
  "steamerMinPrice": 1.00,
  "steamerMaxPrice": 100.00,
  "drifterMinPrice": 1.00,
  "drifterMaxPrice": 100.00,
  "minVolume": 1,
  "countries": ["GB", "IL"]
}

const style1 = {
  color: '#92f7f9',
  textAlign: 'center',
  width: '100%',
}
const back1 = {
  background: '#3b7d35',
  alignItems: 'center',
  height: '45px'
}

const navBarStyle = {
  height: '60px',
  alignContent: 'center'

}


class ControlledTabs extends React.Component {

  timer = null;

  constructor(props, context) {
    super(props, context);
    this.state = {
      key: 'RacesNRunners',
      steamers: [],
      drifters: [],
      userInfo: "",
      selectedDate: currentDateStr(),
      displayTicks: false,
      bfFunds: {},
      displayResult: 'Price Movement',
      displayConfirmBox: true
    };
    this.requestBfFundInfo();
  }

  selectedDateChangeHandler = (event) => {
    const newDate = passDateToString(event);
    this.setState({
      selectedDate: newDate
    })
  }

  handleConfirmOption = (event) => {
    console.log("handleConfirmOption: " + event.target.checked)
     this.setState({
      displayConfirmBox: event.target.checked
    })
    store.dispatch(updateDisplayConfirmBox(event.target.checked))
  }

  displayTickedCheckChangedHandler = (value) => {
    this.setState({
      displayTicks: value
    })
  }
  handleSelect = (evt) => {
    //console.log(evt);
    this.setState({
      displayResult: evt
    })
  }

  reloadView() {
    //console.log("reloadView called: " + this.timer);
    if (this.timer != null) {
      clearInterval(this.timer);
    }
    this.testing();
    this.requestBfFundInfo();
    this.timer = setInterval(() => {
      //console.log("Recursively right table is loading....");
      this.testing()
      this.requestBfFundInfo();
    }, 120000)
  }

  testing() {
    this.mounted = true;

    postRequestPara.countries = store.getState().filteredCountryList
    postRequestPara.steamerMinPrice = store.getState().StearmerDrifterSettings.STEAMER_MIN_PRICE
    postRequestPara.steamerMaxPrice = store.getState().StearmerDrifterSettings.STEAMER_MAX_PRICE
    postRequestPara.drifterMinPrice = store.getState().StearmerDrifterSettings.DRIFTER_MIN_PRICE
    postRequestPara.drifterMaxPrice = store.getState().StearmerDrifterSettings.DRIFTER_MAX_PRICE
    postRequestPara.minVolume = store.getState().StearmerDrifterSettings.MIN_VOLUME

    let timestamp = moment().tz("Etc/GMT")
    if (store.getState().t0Settings.option != "exact") {
      //console.log("exact seelctio nnn ");
      timestamp = timestamp.add(-store.getState().t0Settings.diff, 'minutes');
      //console.log("Result of API 3 time reduced :: " + timestamp.format("YYYYMMDD-HH:mm:ss")); //"time": "20190408-14:15:40",
    } else {
      timestamp = moment(store.getState().exactTimeSettings.t0, 'HH:mm');
      if (timestamp > moment()) timestamp = timestamp.subtract(1, 'days');
      //console.log("Result of API 3 time :: " + timestamp.format("YYYYMMDD-HH:mm:ss"))
    }

    postRequestPara.time = timestamp.format("YYYYMMDD-HH:mm:ss")
    //console.log("Result of API 3 countries :: " + postRequestPara.countries);
    //console.log("Result of API 3 time :: " + timestamp.format("YYYYMMDD-HH:mm:ss")); //"time": "20190408-14:15:40",


    this.serverRequest =
      axios.post(API3, postRequestPara)
        .then((res) => {
          // console.log("Result of API 3 ::" + res.data)
          window.response12 = res.data
          this.setState({
            steamers: res.data.steamers,
            drifters: res.data.drifters
          })
        },
          (error) => {
            // console.log("Result of API 3 returns Error!!!" + error)
          });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(prevProps) {
    
  }

  

  async componentDidMount() {
    if (this.state.key != null && this.state.key === "stemsNDrift") {
      this.reloadView()
    }
    try {
      this.fundTimer = setInterval(() => {
        this.requestBfFundInfo()
      }, 5000)

      const info = await Auth.currentUserInfo()
      //console.log('Returned info: ', info)
      this.setState({
        userInfo: info.attributes.email

      })
    } catch (e) {
      //console.log("Error");
      //alert(e.message);
    }
  }



  handleBetfairLogout = () => {
    clear();
    store.dispatch(updateLoginToken(null));
  }

  handleLogout = async event => {
    await Auth.signOut();
    this.props.userHasAuthenticated(false);
    this.handleBetfairLogout();
  }



  tabOnSelectHandler = key => {
    //console.log("tabOnSelectHandler called.")
    if (key === "stemsNDrift") {
      this.reloadView()
    }
    this.setState({ key: key });
  }

  requestBfFundInfo = () => {
    if(!getLoginToken() || getLoginToken() === ""){
      return;
    }
    const postRequestPara = {
      "ssoid": getLoginToken()
    }
    axios.post(API_BF_FUND, postRequestPara)
      .then((res) => {
        //console.log("requestBfFundInfo. Result of API Winner ::" + res.data)
        const currentState = { ...this.state }
        currentState.bfFunds = res.data
        this.setState(currentState)
      },
        (error) => {
          //console.log("requestBfFundInfo. Error occurred when reading Winner info")
        });
  }


  getBfLogoutButton = () => {
    return <Button
      onClick={this.handleBetfairLogout} variant="contained" color="secondary">
      Bf Logout
    </Button>
  }

  getCurrencySymbol = () => {
    try {
      return getCurrencySymbol(this.state.bfFunds.accountDetailsResponse.currencyCode);
    } catch (error) {
      console.log("error formatting currency symbol")
    }
    return "";
  }

  decimalPlace = (num) => {
    try {
      return (Math.round(num * 100) / 100).toFixed(2);
    } catch (error) {
      return "Fetching";
    }
  }

  getFundInformation = () => {
    return getUserName() && this.state.bfFunds && this.state.bfFunds.fundsResponse ?
        'Balance:  ' + 
        this.getCurrencySymbol() +
        this.decimalPlace(this.state.bfFunds.fundsResponse.availableToBetBalance - this.state.bfFunds.fundsResponse.exposure) +
        '/' +
        this.decimalPlace(this.state.bfFunds.fundsResponse.availableToBetBalance)
      :
      null
  }

  render() {
    const headerImage = (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Image style={{ height: '51px', width: '304px', marginTop: '27px' }} src={require('./assets/header_gpm.jpg')} fluid />
      </div>
    );

    
    return (
      <div >
        <nav style={navBarStyle} class="navbar navbar-dark bg-dark">
          <div class="timeStyle box2">Welcome {this.state.userInfo}</div>
          <div class="timeStyle box2">{headerImage}</div>
          <div class="timeStyle box2" style={{ display: "flex", fontSize: "14px" }}>
            <div style={{ margin: "15px", padding: "5px" }}>
              {this.getFundInformation()}
            </div>
            <div style={{ margin: "15px", padding: "5px" }}>
              {getUserName() ? 'User:  ' + getUserName() : null}
              {'    '}
            </div>
            <div style={{ margin: "5px", padding: "5px" }}>
              {getLoginToken() ? this.getBfLogoutButton() : null}
            </div>
          </div>
          <div class="timeStyle box2">
            <Button variant="contained" color="primary" onClick={this.handleLogout}>
              Logout
              <Icon >logout</Icon>
            </Button>
          </div>
        </nav>
        <div style={back1}>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" onClick={() => this.props.openSideBar(true)}>
              settings
              <Icon >settings</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" id="downloadBtn" onClick={() => clickEvent()}>
              export
              <Icon >arrow_downward</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" onClick={() => this.reloadView()}>
              refresh
              <Icon >refresh</Icon>
            </Button>
          </div>
          <div class="timeStyle box2">
            <Button size="small" variant="contained" color="primary" href="https://winningmore.com/manual.htm" target="_blank">
              user guide
              <Icon >menu</Icon>
            </Button>
          </div>
          <div class="timeStyle box2" style={{ fontSize: '14px' }}>
            <DatePicker selectedDate={this.state.selectedDate} selectedDateChanged={this.selectedDateChangeHandler} />
          </div>
          <div class="timeStyle box2" style={{ marginLeft: '90px', color: 'black', fontSize: '14px' }}>
            <BootstrapSwitchButton key="displayTicksCheckBox"
              checked={this.state.displayTicks}
              id="displayTicksCheckBox"
              size="sm"
              width={119}
              onlabel="Hide Ticks"
              offlabel="Show Ticks"
              onChange={(checked) => { this.displayTickedCheckChangedHandler(checked) }}
            />
          </div>
          <div className="timeStyle box2" onSelect={this.selectDropDown}
            style={{ marginLeft: '0px', color: 'black', fontSize: '14px' }}>
            <Dropdown size="sm" title='Select Value' onSelect={this.handleSelect}>
              <Dropdown.Toggle size="sm" style={{ backgroundColor: '#303f9f' }}>
                {this.state.displayResult}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey="Price Movement">Price Movement</Dropdown.Item>
                <Dropdown.Item eventKey="Market Movement">Market Movement</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="timeStyle box2" onSelect={this.selectDropDown}
            style={{ marginLeft: '20px', color: 'black', fontSize: '14px' }}>
              <Form>
          <Form.Check 
            type='checkbox'
            checked={this.state.displayConfirmBox}
            label={'Show Confirm'}
            onChange={(checked) => { this.handleConfirmOption(checked) }}
          />
          </Form>
          </div>
          

          <div class="timeStyle box3">
            <Button size="small" style={{ fontSize: '0.75em' }} variant="contained" color="primary">
              Time (LOCAL) : <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} />
            </Button>
          </div>
          <div class="timeStyle box3">
            <Button size="small" style={{ fontSize: '0.75em' }} variant="contained" color="secondary">
              Time (UK) : <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} timezone={'Europe/London'} style={{ fontSize: '1.2em' }} />
            </Button>
          </div>

        </div>
        <div class="zstore">
          <Tabs
            defaultActiveKey="CurrencyBoard"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="CurrencyBoard" title="Race">
              <CurrencyBoard tabSelected={this.state.key} displayTicks={this.state.displayTicks}
                displayResult={this.state.displayResult} selectedDate={this.state.selectedDate} />

            </Tab>
            <Tab eventKey="Unmatched Bets" title="Unmatched">
              <div><BfResult showDateDropDown="false" refreshTime="2000"
                type="current" filterStatus="EXECUTABLE"></BfResult></div>
            </Tab>
            <Tab eventKey="CurrentBets" title="Matched Bets">
              <div><BfResult showDateDropDown="false" refreshTime="3000"
                type="current" filterStatus="EXECUTION_COMPLETE"></BfResult></div>
            </Tab>
            <Tab eventKey="Lapse" title="Lapse Bets">
              <div><BfResult type="cleared"
                showDateDropDown="false" refreshTime="20000"
                filterBetStatus={["VOIDED", "LAPSED", "CANCELLED"]}></BfResult></div>
            </Tab>
            <Tab eventKey="Settled" title="Settled Bets">
              <div><BfResult type="cleared"
                showDateDropDown="true" refreshTime="30000"
                filterBetStatus={["SETTLED"]}></BfResult></div>
            </Tab>
          </Tabs>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    loginToken: state.loginToken,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLoginToken: payload =>
      dispatch({ type: UPDATE_TOKEN, payload: payload }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlledTabs);
